import type { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { button, cardBackround, gradient } from '@/styles/shared';

export const CardWrapper = styled.div<{
  children: ReactNode;
  promoted: boolean;
}>`
  height: 100%;
  ${cardBackround};

  ${({ promoted }) =>
    promoted &&
    css`
      display: flex;
      height: 360px;
      grid-column: span 2;
    `}

  img {
    transform: scale(1.01);
  }

  :hover {
    img {
      transform: scale(1.1);
    }
  }

  p,
  h2 {
    color: ${({ theme }) => theme.palette.dark};
  }
`;

export const ImageWrapper = styled.div<{
  children: ReactNode;
  promoted: boolean;
}>`
  height: 205px;
  overflow: hidden;
  width: 100%;
  position: relative;

  ${({ promoted }) =>
    promoted &&
    css`
      height: 100%;
    `}

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 5px 5px 0 0;
    transition: all 0.3s ease;

    ${({ promoted }) =>
      promoted &&
      css`
        width: 360px;
      `}
  }
`;

export const TextWrapper = styled.div<{
  children: ReactNode;
  promoted: boolean;
}>`
  padding: 10px 25px;
  width: 100%;
  position: relative;

  button {
    ${button};
    position: absolute;
    bottom: 20px;
    width: max-content;
    left: 50%;
    transform: translateX(-50%);
  }

  ${({ promoted }) =>
    promoted &&
    css`
      ::after {
        content: '';
        width: 100%;
        height: 7px;
        background: ${gradient};
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 0 4px 0 0;
      }
    `};
`;
